export const CalendarIcon = (ps: React.SVGAttributes<SVGElement>) => (
  <svg
    width="27"
    height="30"
    viewBox="0 0 27 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...ps}>
    <path
      d="M24 3H22.5V0H19.5V3H7.5V0H4.5V3H3C1.335 3 0.015 4.35 0.015 6L0 27C0 28.65 1.335 30 3 30H24C25.65 30 27 28.65 27 27V6C27 4.35 25.65 3 24 3ZM24 27H3V12H24V27ZM9 18H6V15H9V18ZM15 18H12V15H15V18ZM21 18H18V15H21V18ZM9 24H6V21H9V24ZM15 24H12V21H15V24ZM21 24H18V21H21V24Z"
      fill="#999999"
    />
  </svg>
);
